import { useEffect, useState } from "react";
import { HttpMainApi } from "../../interface/main-api";
import { HttpUnAuthApi } from "../../interface/unauth-api";
import { useWindowSize } from "../../utils/useWindowSize";

interface propsType {
  index: number;
  runwayInfo: runwayInfoType;
  imgtype: string;
  checked: boolean;
  callback: any;
}

type runwayInfoType = {
  pk: string;
  sk: string;
  city: string;
  imglist: any;
  mainimg: string;
  designer: string;
  season: string;
  gender: string;
}

const unAuthAPI = new HttpUnAuthApi();

const CardImage = (props: propsType) => {
  const windowSize = useWindowSize();
  const isNarrow = (windowSize?.width ?? 0) <= 1023; // 1024 미만이면 모바일 취급
  const [imgSrc, setImgSrc] = useState("");

  useEffect(() => {
    // getImgUrl();
    // console.log("maining: ", props.runwayInfo.mainimg);
    // console.log("cardImage displaylist : ", props.runwayInfo);
  }, [props.runwayInfo]);

  return (
    <>
      <div 
        className="brief-box one-third"
        style={{
          width:
            windowSize.width >= 1024
              ? "23%"
              : windowSize.width >= 640
              ? "31.3%"
              : "48%",
          marginBottom: "48px",
        }}
        onClick={() => {
          props.callback({ 
            command: "goRunway", 
            key: `${props.runwayInfo.season}#${props.runwayInfo.designer}`,
          });
        }}
      >
        <div className="thumb-img" style={{ height: isNarrow?'273px':'303px' }}>
          <img src={props.imgtype !== "" ? props.runwayInfo.imglist[0] : props.runwayInfo.mainimg} />
        </div>

        <div className="brief-cont">
          <div className="main-brief">
            <div className="brief-summary" style={{ width: '100%' }}>
              <dl>
                <dt style={{ marginBottom: '4px' }}>
                  <p>{props.runwayInfo.designer}</p>
                </dt>
                <dd>{props.runwayInfo.season}</dd>
              </dl>
            </div>

            <div 
              className="checkbox-wrap" 
              onClick={(e) => e.stopPropagation()}
              style={{ top: '7%', left: '15px' }}
            >
              <input
                type="checkbox"
                id={`checkRunway${props.index + 1}`}
                className="check-brief"
                onClick={() => {
                  props.callback({
                    command: "selectRunway",
                    key: `${props.runwayInfo.season}#${props.runwayInfo.designer}`,
                  });
                }}
                onChange={(e) => {}}
                checked={props.checked}
              />
              <label htmlFor={`checkRunway${props.index + 1}`}></label>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default CardImage;